

define(['squid/index', './directive'], function (squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('xo-add-bank.sepa.route', ['squid', 'xo-add-bank.sepa.directive']).factory('$XOSepaRoute', function ($ComponentRoute) {

        return $ComponentRoute.extend('SepaRoute', {

            name: 'sepa',
            directive: 'xo-sepa',
            titleContent: 'DEMemberGuest.sepaTitle',
            trackingData: {
                fptiState: 'sepa_mandate'
            },
            loginRequired: true,
            children: []
        });
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-wallet-components/src/add-bank/sepa/route.js
// module id = ./components/xo-wallet-components/src/add-bank/sepa/route.js
// module chunks = 1